export default {
  notification: {
    visible: false,
    message: '',
  },
  title: '',
}
